module.exports = __webpack_public_path__ + "static/img/icon_home_frisst_title.c9b4fac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_home_frisst_title.svg
// module id = 7B4p
// module chunks = 1